import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
} from "@mui/material";
import customOne from "./assets/custom/custom_1.png";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

import customFive from "./assets/custom/custom_5.png";
import customSeven from "./assets/custom/custom_7.jpg";
import SAS from "./assets/custom/SAS_PRODUCT.png";
import AR_VR from "./assets/custom/ARANDVRPRODUCT.png";
import ConnectedProduction from "./assets/custom/CONNECTED_PRODUCT.png";
import AIProduct from "./assets/custom/AI_PRODUCT.png";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { IconButton } from "@mui/material";

import { Divider } from "@mui/material";
import { useLocation } from "react-router-dom";

import Footer from "./footer";
import expertiseOne from "./assets/tech/tech_1.png";
import expertiseTwo from "./assets/tech/tech_2.png";
import expertiseThree from "./assets/tech/tech_3.png";
import expertiseFour from "./assets/tech/tech_4.webp";
import expertiseFive from "./assets/tech/tech_5.png";
import expertiseSix from "./assets/tech/tech_6.png";
import expertiseSeveen from "./assets/tech/tech_7.webp";
import expertiseEight from "./assets/tech/tech_8.gif";
import expertiseNine from "./assets/tech/tech_9.png";
import expertiseEleveen from "./assets/tech/tech_11.png";
import tripture from "./assets/project_logs/tripture.jpeg";

import sunil from "./assets/about_us/sunil.webp";
import deepak from "./assets/about_us/deepak.jpeg";
import girish from "./assets/about_us/girish.jpg";
import lalith from "./assets/about_us/lalith.jpeg";
import madhu from "./assets/about_us/madhu.png";
import nagz from "./assets/about_us/nagz.png";
import sarvana from "./assets/about_us/sarvana.jpeg";
import shilpa from "./assets/about_us/shilpa.png";
import vijayShree from "./assets/about_us/vijayshree.png";
import hemanth from "./assets/about_us/hemanth.jpeg";
import sandeep from "./assets/about_us/sandeep.png";
import Shruti from "./assets/about_us/Shruti.jpeg";

const AboutUsLinus100 = () => {
  const { pathname } = useLocation();

  const expertiseImages = [
    expertiseOne,
    expertiseTwo,
    expertiseFour,
    expertiseFive,
    expertiseSix,
    expertiseSeveen,
    expertiseEight,
    expertiseNine,
    expertiseEleveen,
    expertiseThree,
  ];

  const scrollRef = useRef(null);

  const scroll = (direction) => {
    const container = scrollRef.current;
    if (container) {
      const scrollAmount = 300; // adjust how far it scrolls
      container.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const recentWorkData = [
    {
      title: "Tripture",
      description:
        "Tripture is a comprehensive booking platform designed for seamless reservations of homestays, villas, and vacation rentals. It features a robust booking engine that supports dynamic property rendering based on user preferences and real-time availability. The system includes advanced search filters, calendar-based availability, and property detail pages optimized for user engagement. Integrated with secure payment gateways, Tripture ensures smooth and trustworthy transactions for users. The platform is built to handle high traffic efficiently while offering property owners a user-friendly backend to manage listings, pricing, and bookings, making it a complete end-to-end solution for the travel accommodation market.",
      image: tripture,
    },
    {
      title: "TheWoods.Living",
      description:
        "TheWoods.Living is a real estate investment platform designed specifically for investors interested in property-based opportunities. The platform showcases a curated selection of properties available for investment, allowing users to explore detailed listings, view pricing, and analyze potential returns. Investors can easily assess each property’s investment potential through transparent data on cost, location, and projected ROI. The interface is tailored to simplify the decision-making process by offering tools to compare listings and track investment performance. Whether you're a first-time investor or expanding your portfolio, TheWoods.Living provides a streamlined and informed path to property investment.",
      image: expertiseOne,
    },
    {
      title: "Medical Transmission",
      description:
        "Medical Transmission is a cross-platform mobile application built using React Native, designed to streamline communication between doctors and patients. Available on both Android and iOS, the app offers a hybrid experience that maintains native performance and user-friendly functionality. It features real-time voice communication through integrated speech-to-text technology powered by Google, enabling patients to speak naturally while the app converts their words into text for doctors to review. Additionally, the app leverages the device’s native audio recording capabilities, allowing users to record and share voice messages securely. This is particularly useful in situations where patients are unable to type or require quick communication. With its intuitive interface and powerful backend, Medical Transmission enhances telemedicine by making remote consultations more accessible and efficient for both patients and healthcare providers.",
      image: expertiseOne,
    },
    {
      title: "Flight Booking ChatBot",
      description:
        "Flight Booking ChatBot is an intelligent conversational assistant designed to simplify the flight booking process through natural dialogue. Built using the InfoBip platform, the chatbot provides a seamless user experience by guiding users through flight search, selection, and reservation—all within a chat interface. Users can simply enter their travel details (such as destination, dates, and passenger info), and the chatbot interacts in real time to suggest flight options and finalize bookings.The system is integrated with third-party APIs that offer live flight listings, pricing, and availability. Once the user confirms a flight, the chatbot processes the booking securely through the same API. This eliminates the need to visit external websites or apps, creating a frictionless and intuitive flight booking experience directly through platforms like WhatsApp, web, or in-app chat.",
      image: expertiseOne,
    },
    {
      title: "mWallet",
      description:
        "mWallet is a secure and user-friendly QR-based mobile wallet application developed natively for both Android and iOS platforms. Designed to offer fast and contactless payments, mWallet allows users to link their bank accounts or cards and make purchases by simply scanning a merchant’s QR code. It is built with robust encryption and real-time transaction tracking to ensure safety and transparency. This application is tailored for everyday users, offering convenience in making payments at retail outlets, online stores, and service points. With features like transaction history, balance updates, and multi-factor authentication, mWallet provides a complete digital payment experience while ensuring smooth performance and a consistent native feel on both platforms.",
      image: expertiseOne,
    },
    {
      title: "Power Battery",
      description:
        "Power Battery is an advanced battery management and listing platform designed to help users easily find batteries based on car models, voltage requirements, and brand preferences. The system allows users to filter and view a wide range of batteries from various manufacturers, ensuring compatibility with different vehicles. Users can access detailed specifications, including voltage ratings and performance features, to make informed decisions. The backend is powered by a robust serverless architecture on AWS, enabling high scalability and seamless performance. The user dashboard and battery management functionalities are developed on Salesforce, offering a powerful interface for administrators. The admin dashboard allows for easy uploading and updating of battery inventories, managing brand data, and setting filtering parameters—making the platform both efficient and easy to maintain.",
      image: expertiseOne,
    },
  ];

  const teamMembers = [
    {
      name: "Sunil Kumar J",
      role: "Founder",
      image: sunil,
      description1:
        "I’m Sunil, the Founder of this company, with over 12 years of experience in the software development industry. My journey spans a deep expertise in Android and iOS app development, where I’ve architected and delivered mobile solutions across multiple domains. I have strong proficiency in backend development, including scalable server-side architecture, API integrations, and secure database management. My experience also includes working extensively with Linux-based servers, enabling me to manage deployments, infrastructure automation, and system-level troubleshooting. Over the years, I’ve built and deployed intelligent chatbot systems, integrating natural language processing and third-party APIs to streamline customer interactions. As a technical leader, I’ve successfully led diverse teams, ensuring quality delivery of complex projects from planning to production. I’ve also implemented and overseen secure payment gateway integrations, with expertise in compliance, QR-based payments, and financial transaction systems. My strength lies in combining technical depth with a practical, solution-driven approach to solve real business problems.",
    },
    {
      name: "Nagendra",
      role: "Co-Founder, Sales and Digital Marketing",
      image: nagz,
      description1:
        "Nagendra is a key member of our team, leading efforts in Sales and Digital Marketing. With a strong grasp of modern marketing strategies and digital platforms, he plays a vital role in building our brand presence and driving customer engagement. His expertise spans lead generation, SEO, performance marketing, social media campaigns, and conversion optimization. Nagendra works closely with our product and development teams to align messaging, highlight unique value propositions, and ensure our offerings reach the right audience. His ability to analyze market trends and customer behavior enables him to design campaigns that not only attract leads but also convert them into long-term clients. His contributions are crucial to our continued growth and customer outreach.",
    },
    {
      name: "Madhu",
      role: "Digital and Media, Manager",
      image: madhu,
      description1:
        "Madhu has 12 years of experience across a unique blend of electrical engineering and computer science. With deep technical roots and a strategic mindset, he leads our technology vision, from hardware integration to advanced software systems. Madhu specializes in device-level development, managing the full cycle of hardware assembly, embedded systems programming, and firmware design. On the software side, he has strong command over Linux environments, backend development, and emerging technologies like Artificial Intelligence and Machine Learning. His multidisciplinary expertise ensures seamless synergy between hardware and software, which is especially critical in smart device ecosystems and intelligent automation platforms. As CTO, Madhu also oversees system architecture, infrastructure planning, and scalability strategies, constantly pushing boundaries to bring innovation into every product we build.",
    },

    {
      name: "Deepak",
      role: "Sales, Digital Marketing",
      image: deepak,
      description1:
        "Deepak is a seasoned Sales and SEO with over 14 years of experience in helping businesses grow their digital footprint and close high-value deals. He collaborates closely with Nagendra and his team, bringing strategic insights and execution to both sales pipelines and search engine visibility. With a strong background in client engagement and consultation, Deepak excels at building lasting relationships and understanding business needs from the ground up. His dual focus on SEO strategy and sales enablement allows him to bridge the gap between marketing and revenue, ensuring that every campaign is aligned with tangible business outcomes. In his role, Deepak also takes the lead in client interactions, offering tailored solutions, managing expectations, and driving satisfaction. His communication skills and consultative approach make him a trusted partner for both internal teams and external stakeholders.",
    },
    {
      name: "Girish",
      role: "Java Backend, Consultant",
      image: girish,
      description1:
        "Girish is a highly experienced Seasonal Consultant specializing in Java backend development and enterprise-level software architecture. With a deep understanding of scalable systems and modular backend design, he has played a pivotal role in multiple high-impact projects. Girish is particularly known for his expertise in software architecture, where he has successfully designed and led the implementation of robust backend solutions. His architectural decisions ensure performance, maintainability, and long-term scalability of the systems he oversees. Over the years, Girish has contributed to the design, review, and optimization of various backend frameworks and microservices, often stepping in during complex phases of product development. His ability to quickly assess technical challenges and deliver reliable backend structures makes him a valuable asset in critical project phases.",
    },
    {
      name: "Lalith",
      role: "Full Stack Developer",
      image: lalith,
      description1:
        "Lalith is a skilled Full Stack Developer with a strong focus on AWS Serverless architecture and modern JavaScript frameworks. His expertise spans across Node.js, React.js, and Angular, enabling him to build efficient, scalable, and high-performance applications from the ground up. Lalith is particularly proficient in serverless computing using AWS services such as Lambda, API Gateway, DynamoDB, and S3. This allows him to develop backend systems that are not only cost-effective but also highly maintainable and resilient. With hands-on experience in both frontend and backend technologies, Lalith bridges the gap between UI/UX and infrastructure. He is known for delivering clean, secure code and building applications that are responsive, fast, and cloud-optimized.",
    },
    {
      name: "Sarvana",
      role: "Full Stack Developer",
      image: sarvana,
      description1:
        "Sarvana is a proficient Full Stack Developer with deep expertise in modern web technologies including Node.js, React.js, and Angular. He specializes in building end-to-end applications that are scalable, responsive, and optimized for performance. With strong backend knowledge in Node.js, Sarvana creates robust server-side logic and RESTful APIs, while his frontend skills in React and Angular allow him to craft seamless and dynamic user experiences. His experience spans building enterprise-grade web platforms, integrating third-party services, and maintaining clean and modular codebases. Sarvana is passionate about developing efficient solutions that solve real-world problems. He is a reliable team player who contributes across the full development lifecycle, from planning and architecture to deployment and maintenance.",
    },
    {
      name: "Hemanth Kumar",
      role: "DevOps Engineer",
      image: hemanth,
      description1:
        "Hemanth is an experienced DevOps Engineer specializing in cloud infrastructure and automation. With strong expertise in AWS and Google Cloud Platform (GCP), he focuses on deploying and maintaining scalable, secure, and cost-effective cloud environments. He is skilled in setting up CI/CD pipelines, managing containerized applications using Docker and Kubernetes, and automating infrastructure using tools like Terraform and Ansible. Hemanth ensures high system availability and performance by implementing best practices in monitoring, logging, and cloud security. His cloud-agnostic experience across AWS and GCP makes him a versatile engineer who can adapt to any cloud-native environment. Hemanth plays a critical role in streamlining development workflows, reducing deployment times, and enabling faster product releases.",
    },
    {
      name: "Sanddep Kumar",
      role: "UI/UX Designer, Mentor",
      image: sandeep,
      description1:
        "Sandeep is a creative and detail-oriented UI/UX designer with a strong foundation in Figma and design systems. He is responsible for translating ideas into intuitive, user-centered interfaces that enhance the user experience across web and mobile platforms. In addition to crafting visually engaging designs, Sandeep actively participates in client interactions, understanding their brand identity and design needs to deliver tailored visual solutions. His contributions also extend to branding and visual storytelling, ensuring consistency and appeal across all digital touchpoints.",
    },
    {
      name: "Shruti Khobare Patil",
      role: "UI/UX Designer",
      image: Shruti,
      description1:
        "A highly motivated and detail-oriented UI/UX Designer with a passion for creating intuitive, user-centered digital experiences. Skilled in translating business requirements into elegant, functional design solutions, with a strong focus on usability, accessibility, and aesthetics. With a background in both user research and visual design, Shruti Khobare Patil bridges the gap between user needs and technical implementation. She follows a design thinking approach, beginning with empathizing with users through research, followed by ideation, prototyping, testing, and iteration. Adept at collaborating with cross-functional teams—including developers, product managers, and marketers—to deliver solutions that not only look good but solve real problems effectively.",
    },
    {
      name: "Shilpa Shree",
      role: "Quality Assurance Engineer",
      image: shilpa,
      description1:
        "Shilpa Shree is QA Engineer with deep expertise in testing across Android, iOS, and backend REST APIs. She ensures product reliability and performance through comprehensive manual and automation testing processes. Shilpa designs detailed test plans, performs regression testing, and identifies bugs early in the development cycle to maintain high-quality standards. Her keen eye for detail and commitment to quality assurance help deliver stable and user-friendly applications to end-users.",
    },
    {
      name: "VijayShree",
      role: "Human Resources & Team Management",
      image: vijayShree,
      description1:
        "VijayShree leads HR, recruitment, and team management, bringing strong organizational and people skills to the company. She plays a crucial role in identifying top talent, conducting interviews, and onboarding team members. Her responsibilities include managing team well-being, aligning HR strategies with business goals, and ensuring smooth communication between departments. VijayShree also helps nurture a positive work culture by focusing on employee engagement, retention, and personal growth within the organization.",
    },

    ,
  ];

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const handleOpenDialog = (member) => {
    setSelectedMember(member);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedMember(null);
  };

  const intervalRef = useRef(null);
  const [scrollAmount, setScrollAmount] = useState(0);

  const scrollSpeed = 3;

  // Auto-scroll effect

  const stopAutoScroll = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  // Manual Scroll Handler
  const scrollBy = (offset) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: offset, behavior: "smooth" });
    }
  };

  return (
    <Box>
      <Box maxWidth="100%">
        <Box
          sx={{
            position: "relative",
            minHeight: { xs: "50vh", md: "50vh" },
            backgroundImage: `url(${customOne})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {/* Blurred Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(8px)",
              zIndex: 1,
            }}
          />

          {/* Text Content */}
          <Box
            sx={{ maxWidth: "auto", mb: 4, zIndex: 2, pt: { xs: 5, md: 0 } }}
          >
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                color: "white",
                fontWeight: 700,
                fontSize: { xs: "1.2rem", md: "1.5rem" },
              }}
            >
              About Linus100
            </Typography>
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                color: "white",
                fontWeight: 200,
                fontSize: { xs: "1.2rem", md: "1.5rem" },
                pl: { xs: 2, md: 10 },
                pr: { xs: 2, md: 10 },
              }}
            >
              We are a dedicated development and service company specializing in
              delivering custom software solutions tailored to your business
              needs. Our expertise spans across web, mobile, and emerging
              technologies to help you innovate and grow.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        spacing={4}
        alignItems="top"
        justifyContent="center"
        sx={{ flexWrap: "wrap", mt: 5 }}
      >
        {/* Left: Image */}

        <Grid item sx={{ width: { xs: "100%", md: "100%" } }}>
          <Box
            sx={{
              mb: { xs: 0, md: 2 },
              pl: { xs: 2, md: 15 },
              pr: { xs: 2, md: 15 },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "orange",
                textAlign: "left",
                pb: { xs: 2, md: 2 },
              }}
            >
              About Linus100
            </Typography>
            <Typography variant="body1" paragraph>
              Our company is committed to delivering top-notch software
              development services that empower businesses to thrive in the
              digital era. We specialize in crafting custom solutions tailored
              to meet the unique challenges and goals of each client. From web
              and mobile applications to cutting-edge technologies like AI,
              AR/VR, and cloud platforms, we provide end-to-end development
              support that ensures quality, scalability, and seamless user
              experience. Beyond services, we also focus on innovative product
              development, helping organizations bring their ideas to life with
              market-ready software products.
            </Typography>
            <Typography variant="body1" paragraph>
              Our expert team collaborates closely with clients throughout the
              entire lifecycle — from ideation and design to deployment and
              ongoing maintenance. By combining technical expertise with a deep
              understanding of industry trends, we deliver solutions that drive
              growth, efficiency, and long-term success.
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            display: "block",
            justifyContent: "center",
            mb: { xs: 0, md: 2 },
            pl: { xs: 2, md: 15 },
            pr: { xs: 2, md: 15 },
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              color: "orange",
              textAlign: "left",
              pb: { xs: 2, md: 2 },
            }}
          >
            Technology we offer
          </Typography>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              overflow: "hidden",
              py: 2,
            }}
          >
            {/* Left Arrow */}
            <IconButton
              onClick={() => scrollBy(-200)}
              sx={{
                position: "absolute",
                top: "50%",
                left: 0,
                zIndex: 2,
                transform: "translateY(-50%)",
                backgroundColor: "rgba(255,255,255,0.8)",
              }}
            >
              <ArrowBackIosIcon />
            </IconButton>

            {/* Scrollable Images */}
            <Box
              ref={scrollRef}
              sx={{
                display: "flex",
                overflowX: "auto",
                gap: 2,
                px: 6,
                scrollBehavior: "smooth",
                "&::-webkit-scrollbar": { display: "none" },
              }}
            >
              {[...expertiseImages, ...expertiseImages].map((src, index) => (
                <Box
                  key={index}
                  sx={{
                    flex: "0 0 auto",
                    width: 120, // add fixed width for consistent sizing
                    height: 120,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 1,
                  }}
                >
                  <Box
                    component="img"
                    src={src}
                    alt={`img-${index}`}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>
              ))}
            </Box>

            {/* Right Arrow */}
            <IconButton
              onClick={() => scrollBy(200)}
              sx={{
                position: "absolute",
                top: "50%",
                right: 0,
                zIndex: 2,
                transform: "translateY(-50%)",
                backgroundColor: "rgba(255,255,255,0.8)",
              }}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </Box>
        </Box>

        {/* Centered small orange line */}
        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        <Box
          sx={{
            mb: { xs: 0, md: 2 },
            pl: { xs: 2, md: 15 },
            pr: { xs: 2, md: 15 },
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: "bold", mb: 4 }}>
            Our Recent Work
          </Typography>

          <Grid container spacing={4}>
            {recentWorkData.map((work, index) => (
              <Grid key={index} size={{ sx: 12, md: 6 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "top",
                    gap: 2,
                  }}
                >
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                      {work.title}
                    </Typography>
                    <Typography variant="body2">{work.description}</Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>

          <Divider
            sx={{
              mt: 5,
              width: 60,
              mx: "auto",
              borderBottom: "3px solid orange",
              mb: 4,
            }}
          />

          <Typography variant="h4" sx={{ fontWeight: "bold", mb: 4 }}>
            Meet Our Team
          </Typography>

          <Grid
            container
            spacing={{ xs: 2, md: 4 }}
            mt={2}
            marginBottom={"30px"}
          >
            {teamMembers.map((member, index) => (
              <Grid size={{ xs: 12, md: 6 }} key={index}>
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: "start",
                    borderRadius: 3,
                    boxShadow: 3,
                    padding: { xs: 0, md: 2 },
                    overflow: "hidden",
                  }}
                >
                  <Box sx={{ flex: 1, padding: { xs: 2, md: 3 } }}>
                    <CardMedia
                      component="img"
                      image={`${member.image}`}
                      alt={member.name}
                      sx={{
                        width: { xs: "100%", md: "270px" },
                        height: { xs: "auto", md: "320px" },
                        borderRadius: { xs: 0, md: 2 },
                        objectFit: "cover",
                      }}
                    />

                    <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                      <Typography
                        variant="h6"
                        fontWeight="600"
                        fontSize={"28px"}
                        color={"#504F53"}
                        sx={{
                          marginRight: 1,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {member.name}
                        {/* <LinkedInIcon sx={{ fontSize: "30px", ml: 5 }} /> */}
                      </Typography>
                    </Box>

                    <Typography
                      variant="subtitle2"
                      color="#4B5563"
                      gutterBottom
                      fontSize={"16px"}
                      fontFamily={"Lexend"}
                      fontWeight={200}
                      mt={1}
                    >
                      {member.role}
                    </Typography>

                    <Divider
                      sx={{
                        width: 200,
                        borderBottom: "3px solid orange",
                        mb: 1,
                        ml: 0,
                        mt: 1,
                      }}
                    />

                    <Typography
                      variant="body2"
                      color="#4B5563"
                      fontSize="14px"
                      sx={{
                        textAlign: "justify",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        WebkitLineClamp: 6,
                      }}
                    >
                      {member.description1}
                    </Typography>

                    <Typography
                      onClick={() => handleOpenDialog(member)}
                      sx={{
                        cursor: "pointer",
                        color: "#007BFF",
                        fontSize: "14px",
                        fontWeight: 500,
                        marginTop: 1,
                        textDecoration: "underline",
                        display: "inline-block",
                      }}
                    >
                      Show More
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Dialog for Show More */}
          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>
              {selectedMember?.name}
              <Typography variant="subtitle2" color="text.secondary">
                {selectedMember?.role}
              </Typography>
            </DialogTitle>
            <DialogContent
              sx={{
                maxHeight: { xs: "400px", md: "auto" },
                overflowY: { xs: "auto", md: "visible" },
              }}
              dividers
            >
              <Typography variant="body1" paragraph>
                {selectedMember?.description1}
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog}>Close</Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default AboutUsLinus100;
